<template>
	<div class="team">
		<div class="view-title">
			<translate>Team</translate>
		</div>
		<el-tabs type="card" class="teamTab" :active-name="activeTab" @tab-click="onTabClick">
			<!--成员 tab-->
			<el-tab-pane name="members" :label="attrText.member">
				<div class="ssk-wrapper">
					<div class="add-ssk">
						<a href="javascript:;" @click.stop="onShowTeamAddMember()">
							<i class="el-icon-plus"></i>
							<translate>Add Member</translate>
						</a>
						<a href="javascript:;" style="display: none">
							<i class="fa fa-list-alt fa-lg"></i>
							<translate>Batch Import</translate>
						</a>
						<div class="pull-right">
							<el-form :inline="true" class="demo-form-inline">
								<el-select v-model="search.user" :placeholder="attrText.select" class="condition-search" @change="initInput">
									<el-option :label="attrText.name" value="q_name"></el-option>
									<el-option :label="attrText.account" value="q_account"></el-option>
								</el-select>
								<el-input icon="search" :disabled="search.user === ''" v-model.trim="search.val" :on-icon-click="onSearchMemberClick" @keyup.enter.native="onSearchMemberClick" class="search-input"> </el-input>
							</el-form>
						</div>
					</div>
					<el-table :data="team.list" style="width: 100%" :row-class-name="tableRowClassName" v-loading="loading">
						<el-table-column :label="attrText.displayNickname" prop="name"></el-table-column>
						<el-table-column :label="attrText.account" prop="account"></el-table-column>
						<el-table-column :label="attrText.type" width="200">
							<template scope="scope">
								<div class="log-list-name">
									<p v-if="scope.row.is_admin == 0">{{ attrText.ordinary }}</p>
									<p v-if="scope.row.is_admin == 1">{{ attrText.admin }}</p>
									<p v-if="scope.row.is_admin == 2">{{ attrText.auditAdmin }}</p>
									<p v-if="scope.row.is_admin == 3">{{ attrText.optAdmin }}</p>
									<p v-if="scope.row.is_admin == 4">{{ attrText.safeAdmin }}</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.status">
							<template scope="scope">
								<p :style="{ color: '#F56C6C' }" v-if="scope.row.status">禁用</p>
								<p :style="{ color: '#67C23A' }" v-else>启用</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.action" width="300">
							<template scope="scope">
								<router-link :to="{ name: 'settingTeamAccountWorkgroup', params: { id: scope.row.id }, query: { type: 'workgroup', accountName: scope.row.name } }">
									<el-button type="text">
										<translate>Project</translate>
									</el-button>
								</router-link>
								<el-button v-if="account.is_admin == 1" type="text" @click.stop="resetMFA(scope.row, scope.$index)">
									<translate>Reset MFA</translate>
								</el-button>
								<el-button type="text" @click.stop="onShowTeamMemberSetting(scope.row, scope.$index)">
									<translate>Setting</translate>
								</el-button>
								<el-button type="text" @click.stop="changeStatus(scope.row, scope.$index)" :disabled="scope.row.id === $store.getters.account.id || scope.row.is_admin === 1 || $store.getters.account.is_admin != 1">
									<translate v-if="scope.row.status">Enable</translate>
									<translate v-else>Disable</translate>
								</el-button>
								<el-button type="text" :loading="scope.row.deleting" @click.stop.prevent="deleteMember(scope.row)" :disabled="scope.row.id === $store.getters.account.id || scope.row.is_admin === 1 || $store.getters.account.is_admin != 1">
									<translate v-if="!scope.row.deleting">Delete</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination" v-if="team.totalPage > 10">
					<el-pagination layout="total, prev, pager, next" :total="team.totalPage" :page-size="10" :current-page.sync="team.currentPage" @current-change="onChangePage"></el-pagination>
				</div>
			</el-tab-pane>
			<!-- 群组 tab -->
			<el-tab-pane name="group" :label="attrText.group">
				<div class="ssk-wrapper">
					<div class="add-ssk">
						<a href="javascript:;" @click.stop="onShowTeamAddGroup()">
							<i class="el-icon-plus"></i>
							<translate>Create Group</translate>
						</a>
						<div class="pull-right">
							<el-form :inline="true" class="demo-form-inline">
								<el-input v-model.trim="searchGroup.val" :placeholder="attrText.groupInputName" class="search-input" @keyup.enter.native="onSearchGroupClick()"></el-input>
								<el-button class="search-btn" @click="onSearchGroupClick">
									<translate>Search</translate>
								</el-button>
							</el-form>
						</div>
					</div>
					<el-table :data="group.list" style="width: 100%" :row-class-name="tableRowClassName" v-loading="loading">
						<el-table-column :label="attrText.name" prop="name">
							<template scope="scope">
								<router-link :to="{ name: 'settingTeamGroupDetail', params: { id: scope.row.id }, query: { name: scope.row.name } }">
									<a class="el-button--text">{{ scope.row.name }}</a>
								</router-link>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.comment" prop="note">
							<template scope="scope">
								<p>{{ scope.row.note ? scope.row.note : '-' }}</p>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.membersNumber" width="200">
							<template scope="scope">
								<div class="log-list-name">
									<p>{{ scope.row.member_count || 0 }}</p>
								</div>
							</template>
						</el-table-column>
						<el-table-column :label="attrText.action" width="200">
							<template scope="scope">
								<router-link :to="{ name: 'settingTeamGroupWorkgroup', params: { id: scope.row.id }, query: { type: 'workgroup', groupName: scope.row.name } }">
									<el-button type="text">
										<translate>Project</translate>
									</el-button>
								</router-link>
								<el-button type="text" @click.stop="onShowTeamGroupSetting(scope.row, scope.$index)">
									<translate>Setting</translate>
								</el-button>
								<el-button type="text" :loading="scope.row.deleting" @click.stop.prevent="deleteGroup(scope.row, scope.row.member_count)">
									<translate v-if="!scope.row.deleting">Delete</translate>
								</el-button>
							</template>
						</el-table-column>
					</el-table>
				</div>
				<div class="pagination" v-if="group.totalPage > 10">
					<el-pagination layout="total, prev, pager, next" :total="group.totalPage" :page-size="10" :current-page.sync="group.currentPage" @current-change="onChangeGroupPage"></el-pagination>
				</div>
			</el-tab-pane>
			<!-- 设置 tab-->
			<el-tab-pane class="team-set" name="settings" :label="attrText.Setting">
				<el-form :model="settingForm" :rules="rules" ref="teamSetForm" label-width="180px" v-loading="loading" class="demo-ruleForm">
					<el-form-item :label="attrText.code" class="fixed-text">{{ settingForm.domain }}</el-form-item>
					<el-form-item :label="attrText.teamName" prop="fullName">
						<el-input v-model.trim="settingForm.fullName"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.person" prop="contactName">
						<el-input v-model.trim="settingForm.contactName"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.phone" prop="contactPhone">
						<el-input type="tel" v-model="settingForm.contactPhone"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.address" prop="contactAddress">
						<el-input v-model.trim="settingForm.contactAddress"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.ip" prop="ipWhitelist">
						<el-input v-model="settingForm.ipWhitelist" :placeholder="attrText.mutip"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.adminIP" prop="adminWhitelist">
						<el-input v-model="settingForm.adminWhitelist" :placeholder="attrText.mutip"></el-input>
					</el-form-item>
					<el-form-item :label="attrText.codeIPWhitelist">
						<div style="display: flex; align-items: center">
							<el-switch style="margin-right: 16px" v-model="settingForm.codeIpWhitelist" on-text="" off-text=""></el-switch>
							<translate>The creator's IP is added automatically; only whitelisted IPs can connect</translate>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.loginHoldTime" prop="session_expire_time">
						<div class="loginHoldTime">
							<el-input v-model="settingForm.session_expire_time" type="number" :max="480" :min="30" :placeholder="attrText.takesLoginAgain"></el-input>
							<translate>minutes</translate>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.adminUser" v-if="$store.getters.account.unique_id">
						<el-select v-model="settingForm.adminUser" class="settingSelect" style="width: 200px">
							<el-option v-for="(user, index) in adminUserList" :key="index" :value="user.account" :label="user.account" style="height: 50px">
								<p>{{ user.name }}</p>
								<p>{{ user.account }}</p>
							</el-option>
						</el-select>
					</el-form-item>
					<el-form-item :label="attrText.teamToken">
						<div class="teamToken">
							<el-input v-model="settingForm.domain_token" :placeholder="attrText.teamToken" readonly></el-input>
							<el-button type="text" @click="updateTeamToken">
								<translate>Update</translate>
							</el-button>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.bindedWorkSpace">
						<div class="bindedWorkSpace">
							<el-input v-model="settingForm.bindedWorkSpaceName" placeholder="请先绑定工作空间" readonly></el-input>
							<el-button v-if="settingForm.bindedWorkSpaceId" type="text" @click="unbindWorkSpace">
								<translate>Unbind</translate>
							</el-button>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.mfa">
						<el-switch v-model="settingForm.iscompanyMfaOpen" on-text="" off-text=""></el-switch>
					</el-form-item>
					<el-form-item :label="attrText.compelChangePassword">
						<div style="display: flex; align-items: center">
							<el-switch style="margin-right: 16px" v-model="settingForm.iscompanyPassword" on-text="" off-text=""></el-switch>
							<translate>Team members request password changes every 90 days</translate>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.loginLockout">
						<div style="display: flex; align-items: center">
							<el-switch style="margin-right: 16px" v-model="settingForm.loginLockout" on-text="" off-text="" disabled></el-switch>
							<translate>If you enter the password incorrectly 10 times in a row, your account will be locked for 1 hour</translate>
						</div>
					</el-form-item>
					<el-form-item :label="attrText.passwordStrength">
						<el-radio-group v-model="settingForm.passwordStrength">
							<el-radio-button :label="0"><translate>weak</translate></el-radio-button>
							<el-radio-button :label="1"><translate>medium</translate></el-radio-button>
							<el-radio-button :label="2"><translate>strong</translate></el-radio-button>
						</el-radio-group>
						<translate tag="p" style="margin-top: 15px; max-width: 350px" v-show="settingForm.passwordStrength === 0">Team member password complexity is not required</translate>
						<translate tag="p" style="margin-top: 15px; max-width: 350px" v-show="settingForm.passwordStrength === 1">The password must be at least 6 characters long and must contain two types of three:uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )</translate>
						<translate tag="p" style="margin-top: 15px; max-width: 350px" v-show="settingForm.passwordStrength === 2">The password must be at least 8 characters long and must contain uppercase letters, lowercase letters, and special characters. (the existing member will be forced to change the password when logging in. Please notify the relevant member to change the password. )</translate>
					</el-form-item>
					<el-button type="primary" :disabled="!settingForm.isCanSubmit" @click="onSubmitSet()" class="set-btn">
						<translate>Save</translate>
					</el-button>
				</el-form>
			</el-tab-pane>
			<!-- 版本 tab -->
			<!-- <el-tab-pane name="version" :label="attrText.version" class="team-set">
				<el-form label-width="180px" :model="version" class="demo-ruleForm" v-loading="loading">
					<el-form-item :label="attrText.nowVersion">
						<span :class="colorName">{{ version.versionName }}</span>
					</el-form-item>
					<el-form-item :label="attrText.remainTime">
						{{ getTranTest(version.time) }}
					</el-form-item>
					<el-form-item :label="attrText.resource">
						{{ version.haveResource }}
					</el-form-item>
					<el-form-item :label="attrText.user">
						{{ version.haveUser }}
					</el-form-item>
					<el-form-item :label="attrText.cluster">
						{{ version.haveCluster }}
					</el-form-item>
					<el-form-item :label="attrText.shareCluster">
						{{ version.shareCluster }}
					</el-form-item>
					<el-form-item :label="attrText.shareResource" prop="adminWhitelist">
						{{ version.shareResource }}
					</el-form-item>
				</el-form>
			</el-tab-pane> -->

			<!-- SSO tab -->
			<el-tab-pane name="sso" label="SSO" class="sso">
				<el-form :model="ssoForm" :rules="ssoRules" ref="ssoSetForm" label-width="180px" class="sso-form" v-loading="loading" :show-message="false">
					<el-form-item :label="attrText.sso" class="fixed-text">
						<el-switch v-model="ssoForm.is_open" on-text="" off-text=""></el-switch>
					</el-form-item>

					<el-form-item :label="attrText.is_account_password" class="fixed-text">
						<el-switch v-model="ssoForm.is_account_password" on-text="" off-text="" :disabled="!ssoForm.is_open"></el-switch>
					</el-form-item>

					<el-form-item :label="attrText.type" prop="sso_type">
						<el-select v-model="ssoForm.sso_type" :disabled="!ssoForm.is_open">
							<el-option label="SAML2.0" value="SAML"></el-option>
						</el-select>
					</el-form-item>

					<el-form-item :label="attrText.id_vendor" prop="id_vendor">
						<el-input v-model.trim="ssoForm.id_vendor" :placeholder="attrText.id_vendor" :maxlength="64" show-word-limit clearable :disabled="!ssoForm.is_open"></el-input>
					</el-form-item>

					<el-form-item :label="attrText.WriterMetadataDocument" prop="fileList">
						<el-upload :action="uploadAction" drag accept="text/xml" :limit="1" :on-success="uploadSuccess" :on-remove="removeFile" :file-list="ssoForm.fileList" :disabled="!ssoForm.is_open">
							<i class="el-icon-upload"></i>
							<div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
							<p>
								<translate> Only the xml file format is supported. The file size should not exceed 5MB and a maximum of 1 file can be uploaded. </translate>
							</p>
						</el-upload>
					</el-form-item>

					<el-form-item :label="attrText.login_url" prop="login_url">
						<div class="copy-text">
							<el-input v-model.trim="ssoForm.login_url" :placeholder="attrText.login_url" disabled></el-input>
							<el-button type="text" v-clipboard:copy="ssoForm.login_url" v-clipboard:success="copySuccess">
								<i class="fa fa-clone fa-sm"></i>
							</el-button>
						</div>
					</el-form-item>

					<el-form-item :label="attrText.assertion_url" prop="assertion_url">
						<div class="copy-text">
							<el-input v-model.trim="ssoForm.assertion_url" :placeholder="attrText.assertion_url" disabled></el-input>
							<el-button type="text" v-clipboard:copy="ssoForm.assertion_url" v-clipboard:success="copySuccess">
								<i class="fa fa-clone fa-sm"></i>
							</el-button>
						</div>
					</el-form-item>

					<el-form-item :label="attrText.access_white_list" prop="access_white_list">
						<div class="copy-text">
							<el-input v-model.trim="ssoForm.access_white_list" type="textarea" :autosize="{ minRows: 4, maxRows: 10 }" resize="none" placeholder="支持输入多个邮箱域名地址，例如：cloudcare.cn，多个域名用逗号分隔。" :disabled="!ssoForm.is_open"></el-input>
							<el-tooltip>
								<div slot="content"><translate>Emails with the same domain suffix have the permission to obtain the single sign-on access link for this identity provider. When users log in for the first time, the system will dynamically create a CloudLinker member account, eliminating the need to create it in the system in advance.</translate><br /><translate>The default account permission is: Ordinary Member</translate></div>
								<i class="fa fa-question-circle fa-lg"></i>
							</el-tooltip>
						</div>
					</el-form-item>

					<el-button type="primary" :disabled="!ssoForm.isCanSubmit" @click="onSubmitSetSSO()" class="set-btn">
						<translate>Save</translate>
					</el-button>
				</el-form>
			</el-tab-pane>

			<!-- NTP Tab -->
			<!-- <el-tab-pane name="ntp" label="NTP" class="ntp">
				<div class="ntp-wrapper">
					<el-form :model="ntpForm" ref="ntpForm" label-width="180px" class="demo-ruleForm" v-loading="loading">
						<el-form-item :label="attrText.ntpServer" prop="ntpServer">
							<el-input v-model.trim="ntpForm.ntpServer" placeholder="请输入NTP服务器域名或IP地址" clearable></el-input>
						</el-form-item>
						<el-form-item :label="attrText.currentTime">
							<span>{{ (ntpForm.currentTime * 1000) | moment('YYYY-MM-DD HH:mm:ss') }}</span>
						</el-form-item>
						<el-form-item :label="attrText.syncCycle">
							<span>{{ ntpForm.syncCycle }}</span>
						</el-form-item>
						<el-form-item :label="attrText.syncCountdown">
							<span :style="{ color: ntpForm.syncCountdown < 60 ? '#F56C6C' : '#606266' }">{{ ntpForm.syncCountdown }}秒</span>
						</el-form-item>
						<el-form-item label=" ">
							<el-button v-loading="ntpForm.isSyncing" type="primary" @click="onManualSyncNtp()" :disabled="ntpForm.isSyncing">
								<translate>Sync</translate>
							</el-button>
						</el-form-item>
					</el-form>
				</div>
			</el-tab-pane> -->
		</el-tabs>

		<component :is="currentRightPanel" :items="rightPanelData" @onClosePanel="onClosePanel" @callback="callback"></component>
	</div>
</template>

<script>
import STORE_CONST from '../../store/consts'
import TeamAddMember from './model/team-add-member'
import TeamMemberSetting from './model/team-member-setting'
import TeamAddGroup from './model/team-add-group'
import TeamGroupSetting from './model/team-group-setting'
import { baseUrl, Utils } from '../../config'

export default {
	data() {
		return {
			loading: true,
			settingLoading: true,
			activeTab: this.$route.query.type || 'members',
			settingForm: {
				isLoaded: false,
				isCanSubmit: false,
				domain: '',
				fullName: '',
				contactName: '',
				contactPhone: '',
				contactAddress: '',
				ipWhitelist: '',
				adminWhitelist: '',
				codeIpWhitelist: true,
				session_expire_time: 30,
				teamToken: '',
				bindedWorkSpaceName: '',
				bindedWorkSpaceId: '',
				iscompanyMfaOpen: false,
				loginLockout: true,
				passwordStrength: 0,
				adminUser: '',
			},
			uploadAction: `${baseUrl.apiUrl}/sso/parse_metadata`,
			ssoForm: {
				is_open: false,
				is_account_password: true,
				sso_type: 'SAML2.0',
				id_vendor: '',
				login_url: '',
				assertion_url: '',
				access_white_list: '',
				isCanSubmit: false,
				fileList: [],
			},
			// 新增：时钟标签数据
			ntpForm: {
				ntpServer: 'ntp.aliyun.com', // 默认NTP服务器地址
				currentTime: '', // 当前时间（格式：YYYY-MM-DD HH:mm:ss）
				syncCycle: '5分钟', // 固定同步周期
				syncCountdown: 300, // 同步倒计时（秒）
				isSyncing: false, // 是否正在同步中
			},
			countdownInterval: null,
			adminUserList: [],
			team: {
				isLoaded: false,
				totalPage: 0,
				currentPage: 1,
				list: [],
			},
			group: {
				isLoaded: false,
				totalPage: 0,
				currentPage: 1,
				list: [],
			},
			search: {
				isSearch: false,
				user: 'q_name',
				val: '',
			},
			searchGroup: {
				isSearch: false,
				val: '',
			},
			version: {
				versionName: '',
				time: '',
				resource: '',
				cluster: '',
				user: '',
				haveResource: '',
				haveCluster: '',
				haveUser: '',
				shareResource: '',
				shareCluster: '',
			},
			colorName: '',
			versionText: {
				企业版: this.$gettext('Enterprise'),
				旗舰版: this.$gettext('Ultimate'),
				至尊版: this.$gettext('Ultimate'),
				基础版: this.$gettext('Basic'),
				高级版: this.$gettext('Premium'),
				普通版: this.$gettext('Trial'),
				试用版: this.$gettext('Trial'),
			},
			versionColor: {
				企业版: 'test',
				旗舰版: 'ulit',
				至尊版: 'ulit',
				基础版: 'base',
				高级版: '',
				普通版: 'test',
				试用版: 'test',
			},
			rules: {
				// setting form rules
				fullName: [{ required: true, message: this.$gettext('please input the team name'), trigger: 'change' }],
				contactName: [{ required: true, message: this.$gettext('please input the contact name'), trigger: 'change' }],
				contactPhone: [
					{ required: true, message: this.$gettext('please input the contact phone'), trigger: 'change' },
					{
						pattern: /^1[34578]\d{9}$/,
						message: this.$gettext('please input the right contact phone'),
						trigger: 'change',
					},
				],
				contactAddress: [{ required: true, message: this.$gettext('please input the contact address'), trigger: 'change' }],
				ipWhitelist: [
					{
						pattern: /^(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}(,(\d{1,3}|\*)(\.(\d{1,3}|\*)){3})*$/,
						message: this.$gettext('please input the ip whitelist, CIDR address is not allowed'),
						trigger: 'change',
					},
				],
				adminWhitelist: [
					{
						pattern: /^(\d{1,3}|\*)(\.(\d{1,3}|\*)){3}(,(\d{1,3}|\*)(\.(\d{1,3}|\*)){3})*$/,
						message: this.$gettext('please input the ip whitelist'),
						trigger: 'change',
					},
				],
				session_expire_time: [
					{
						pattern: /^(3[0-9]|[4-9][0-9]|[1-3][0-9]{2}|4[0-7][0-9]|480)$/,
						message: this.$gettext('Min. 30 min. 480 min'),
						trigger: 'change',
					},
				],
			},
			ssoRules: {
				// sso form rules
				fileList: [
					{
						validator: (rule, value, callback) => {
							if (this.ssoForm.is_open && this.ssoForm.fileList.length === 0) {
								callback(new Error(this.$gettext('Please upload the metadata document.')))
							} else {
								callback()
							}
						},
						trigger: 'change',
					},
				],
				sso_type: [{ required: true, message: this.$gettext('Please Select Tthe Type'), trigger: 'change' }],
				id_vendor: [
					{ required: true, message: this.$gettext('please input the ID Vendor'), trigger: 'change' },
					{ max: 64, message: this.$gettext('The maximum length can be up to 64 characters.'), trigger: 'change' },
				],
				access_white_list: [{ required: true, message: this.$gettext('Support inputting multiple email domain addresses, for example: cloudcare.cn. Multiple domains should be separated by commas.'), trigger: 'change' }],
			},
			currentRightPanel: null,
			rightPanelData: null,
		}
	},
	computed: {
		attrText() {
			return this.initAttrText()
		},
		account() {
			let currentAccount = this.$store.getters.account
			console.log(currentAccount, 'currentAccount')

			return currentAccount
		},
	},
	created() {
		// load team list data
		this.routeChange(this.$route.query.type)
	},
	methods: {
		getTranTest(number) {
			console.log('number', number)
			if (number >= 0) {
				let translated = this.$ngettext('%{ n } day', '%{ n } days', number)
				let interpolated = this.$gettextInterpolate(translated, { n: number })
				return interpolated
			} else {
				return this.$gettext('expired')
			}
		},
		initInput(val) {
			if (!val) {
				this.search.val = ''
			}
		},
		// 提取翻译文本
		initAttrText() {
			return {
				member: this.$gettext('Member'),
				group: this.$gettext('Group'),
				groupInputName: this.$gettext('Please input Group Name to Search'),
				optAdmin: this.$gettext('Opt Admin'),
				safeAdmin: this.$gettext('Safe Admin'),
				auditAdmin: this.$gettext('Audit Admin'),
				admin: this.$gettext('Administrator'),
				ordinary: this.$gettext('Ordinary User'),
				accountType: this.$gettext('Account Type'),
				select: this.$gettext('Select'),
				name: this.$gettext('Full Name'),
				displayNickname: this.$gettext('Display Nickname'),
				email: this.$gettext('Email'),
				account: this.$gettext('Account'),
				type: this.$gettext('Type'),
				status: this.$gettext('Status'),
				comment: this.$gettext('Comment'),
				membersNumber: this.$gettext('Members Number'),
				action: this.$gettext('Action'),
				code: this.$gettext('Team ID'),
				teamName: this.$gettext('Team Full Name'),
				person: this.$gettext('Contact Name'),
				phone: this.$gettext('Contact Phone'),
				address: this.$gettext('Contact Address'),
				ip: this.$gettext('IP Whitelist'),
				adminIP: this.$gettext('Admin IP Whitelist'),
				codeIPWhitelist: this.$gettext('Code IP Whitelist'),
				loginHoldTime: this.$gettext('Login Hold Time'),
				takesLoginAgain: this.$gettext('It takes effect after you log in again'),
				teamToken: this.$gettext('Team Token'),
				bindedWorkSpace: this.$gettext('Binded Workspace'),
				mfa: this.$gettext('Team MFA Certification'),
				compelChangePassword: this.$gettext('Compel Change Password'),
				loginLockout: this.$gettext('Login Lockout'),
				pwd: this.$gettext('Password'),
				repwd: this.$gettext('Repeat Password'),
				empty: this.$gettext('Leave blank'),
				mutip: this.$gettext('Multiple IP to separate'),
				Setting: this.$gettext('Setting'),
				version: this.$gettext('Version'),
				nowVersion: this.$gettext('Current Version:'),
				resource: this.$gettext('Resources:'),
				user: this.$gettext('users:'),
				cluster: this.$gettext('Clusters:'),
				shareCluster: this.$gettext('Shared Clusters:'),
				shareResource: this.$gettext('Shared Resources:'),
				remainTime: this.$gettext('remaining time:'),
				motify: this.$gettext('Motify'),
				maxResource: this.$gettext('The maximum amount of resources for a single network in the current version is'),
				passwordStrength: this.$gettext('Password Strength'),
				adminUser: this.$gettext('Master Account Binding Administrator'),
				sso: this.$gettext('SSO'),
				WriterMetadataDocument: this.$gettext('Writer Metadata Document'),
				is_account_password: this.$gettext('Enable Password Login'),
				type: this.$gettext('Type'),
				id_vendor: this.$gettext('ID Vendor'),
				login_url: this.$gettext('Login URL'),
				assertion_url: this.$gettext('Assertion URL'),
				access_white_list: this.$gettext('Access Restrictions'),
				// 新增：时钟标签翻译
				ntp: this.$gettext('Clock'),
				ntpServer: this.$gettext('NTP Server'),
				currentTime: this.$gettext('Current Time'),
				syncCycle: this.$gettext('Sync Cycle'),
				syncCountdown: this.$gettext('Sync Countdown'),
				syncSuccess: this.$gettext('NTP sync success'),
			}
		},
		// 清空搜索框
		clearSearchInput() {
			this.search.val = ''
			this.searchGroup.val = ''
		},
		// rightplane callback
		callback() {
			if (this.activeTab === 'members') {
				this.getTeamMemberList(this.team.currentPage)
			} else if (this.activeTab === 'group') {
				this.getTeamGroupList(this.group.currentPage)
			}
		},
		// 获取团队成员列表
		getTeamMemberList(page, total) {
			this.loading = true
			let params = {
				page: page || 1,
			}
			if (total) {
				params.total = total
			}
			if (this.search.val !== '') {
				params[this.search.user] = this.search.val
			}
			this.$store.dispatch(STORE_CONST.TEAM.GET_MEMBER_LIST, { params: params }).then(
				(res) => {
					this.loading = false
					this.team = {
						isLoaded: true,
						totalPage: res.total,
						list: res.objects,
						currentPage: res.page,
					}
				},
				() => {
					this.loading = false
				},
			)
		},
		// 获取为类型为管理员用户的团队成员列表
		getGroupAdminMembers() {
			let params = {
				page: 1,
				page_size: Utils.config.maxPageSize,
				q_is_admin: true,
			}
			this.$store.dispatch(STORE_CONST.TEAM.GET_MEMBER_LIST, { params: params }).then((res) => {
				this.adminUserList = Object.clone(res.objects)
			})
		},
		// 获取群组列表
		getTeamGroupList(page, total) {
			this.loading = true
			let params = {
				page: page || 1,
			}
			if (total) {
				params.total = total
			}
			if (this.searchGroup.val !== '') {
				params.q_name = this.searchGroup.val
			}
			this.$store.dispatch(STORE_CONST.TEAM.GROUP_LIST, { params: params }).then(
				(res) => {
					this.loading = false
					this.group = {
						isLoaded: true,
						totalPage: res.total,
						list: res.objects,
						currentPage: res.page,
					}
				},
				() => {
					this.loading = false
				},
			)
		},
		// 获取当前设置表单数据
		getSettingFormData() {
			this.loading = true
			this.$store.dispatch(STORE_CONST.TEAM.CURRENT).then(
				(res) => {
					console.log(res, 'resres')
					this.settingForm = {
						isLoaded: true,
						domain: res.domain,
						fullName: res.full_name,
						contactName: res.contact_name,
						contactPhone: res.contact_phone,
						contactAddress: res.contact_address,
						ipWhitelist: res.ip_whitelist,
						adminWhitelist: res.admin_whitelist,
						codeIpWhitelist: res.code_ip_whitelist === undefined ? true : Boolean(res.code_ip_whitelist),
						session_expire_time: res.session_expire_time,
						domain_token: res.domain_token,
						bindedWorkSpaceName: res.ee_work_space_name,
						bindedWorkSpaceId: res.ee_work_space_id,
						iscompanyMfaOpen: res.company_mfa,
						iscompanyPassword: res.reset_password, // 控制强制修改密码
						loginLockout: true,
						passwordStrength: res.password_strength,
						adminUser: res.email,
					}
					let userDay = res.current_plan_expire_time - new Date().getTime() / 1000
					this.version.time = Math.ceil(userDay / 60 / 60 / 24)
					this.$store.dispatch(STORE_CONST.TEAM.GET_PLAN).then(
						(res) => {
							this.colorName = this.versionColor[res.plan]
							this.version = Object.assign({}, this.version, {
								versionName: this.versionText[res.plan],
								shareResource: res.shared_resources,
								shareCluster: res.shared_networks,
								haveResource: res.resources,
								haveCluster: res.networks,
								haveUser: res.accounts,
							})
							console.log('colorName', this.colorName)
							this.loading = false
						},
						() => {
							this.loading = false
						},
					)
				},
				() => {
					this.loading = false
				},
			)
		},
		// 更新团队Token
		updateTeamToken() {
			this.$confirm(this.$gettext('After the team token is updated, the original team token will become invalid and the CloudCare workspace bound to it will also be unbound. Exercise caution when performing this operation.'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				this.$store.dispatch(STORE_CONST.TEAM.UPDATE_TEAM_TOKEN).then(() => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Update successfully!'),
					})
					this.getSettingFormData()
				})
			})
		},
		// 重置MFA
		resetMFA(row, index) {
			this.$confirm(this.$gettext('Confirm Whether To Reset The Member Mfa Account?'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				const data = {
					id: row.id,
				}
				this.$store.dispatch(STORE_CONST.TEAM.RESET_MFA, data).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Reset successfully!'),
					})
					this.getSettingFormData()
				})
			})
		},
		// 解绑工作空间
		unbindWorkSpace() {
			this.$confirm(this.$gettext('After the CloudCare workspace is unbound, historical diagnosis reports cannot be viewed. Exercise caution when performing this operation.'), this.$gettext('Please Confirm'), {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				const data = {
					work_space_id: this.settingForm.bindedWorkSpaceId,
					domain: this.settingForm.domain,
				}
				this.$store.dispatch(STORE_CONST.TEAM.UNBIND_WORKSPACE, { data }).then((res) => {
					this.$notify({
						type: 'success',
						message: this.$gettext('Unbind successfully!'),
					})
					this.getSettingFormData()
				})
			})
		},
		// 提交设置当前团队表单
		onSubmitSet() {
			let data = {
				full_name: this.settingForm.fullName,
				contact_name: this.settingForm.contactName,
				contact_phone: this.settingForm.contactPhone,
				contact_address: this.settingForm.contactAddress,
				ip_whitelist: this.settingForm.ipWhitelist,
				admin_whitelist: this.settingForm.adminWhitelist,
				code_ip_whitelist: this.settingForm.codeIpWhitelist ? 1 : 0,
				session_expire_time: this.settingForm.session_expire_time,
				company_mfa: this.settingForm.iscompanyMfaOpen ? 1 : 0,
				reset_password: this.settingForm.iscompanyPassword,
				password_strength: this.settingForm.passwordStrength,
				email: this.settingForm.adminUser,
			}
			this.$store.dispatch(STORE_CONST.TEAM.SET, { data: data }).then((res) => {
				this.$notify({
					message: this.$gettext('Modify team info successfully!'),
					type: 'success',
				})
				this.getSettingFormData()
			})
		},
		// 删除团队成员
		deleteMember(row) {
			this.$confirm(this.$gettext('Are you sure to delete this account!'), this.$gettext('Delete Prompt'), {
				confirmButtonText: this.$gettext('Comfirm'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			})
				.then(() => {
					this.$set(row, 'deleting', true)
					this.$store
						.dispatch(STORE_CONST.TEAM.DELETE, row.id)
						.then((res) => {
							this.clearSearchInput()
							this.getTeamMemberList(1)
							this.$notify({
								type: 'success',
								message: this.$gettext('Delete successfully!'),
							})
						})
						.finally(() => {
							this.$set(row, 'deleting', false)
						})
				})
				.catch(() => {
					this.$set(row, 'deleting', false)
				})
		},
		// 删除团队群组
		deleteGroup(row, memberCount) {
			if (memberCount) {
				this.$alert(this.$gettext('There are members in the group, please delete all members before delete the group!'), this.$gettext('Delete Prompt'), {
					confirmButtonText: this.$gettext('Comfirm'),
					type: 'warning',
				})
			} else {
				this.$confirm(this.$gettext('Are you sure to delete this group!'), this.$gettext('Delete Prompt'), {
					confirmButtonText: this.$gettext('Comfirm'),
					cancelButtonText: this.$gettext('Cancel'),
					type: 'warning',
				})
					.then(() => {
						this.$set(row, 'deleting', true)
						this.$store
							.dispatch(STORE_CONST.TEAM.DELETE_GROUP, row.id)
							.then((res) => {
								this.clearSearchInput()
								this.getTeamGroupList(1)
								this.$notify({
									type: 'success',
									message: this.$gettext('Delete successfully!'),
								})
							})
							.finally(() => {
								this.$set(row, 'deleting', false)
							})
					})
					.catch(() => {
						this.$set(row, 'deleting', false)
					})
			}
		},
		// tab切换
		onTabClick(tab, event) {
			this.$router.push({ name: 'team', query: { type: tab.name } })
			this.activeTab = this.$route.query.type || 'members'
			this.clearSearchInput()
		},
		// 成员分页
		onChangePage(page) {
			this.getTeamMemberList(page, this.team.totalPage)
		},
		// 群组分页
		onChangeGroupPage(page) {
			this.getTeamGroupList(page, this.group.totalPage)
		},
		// 成员搜索
		onSearchMemberClick() {
			this.getTeamMemberList()
		},
		// 群组搜索
		onSearchGroupClick() {
			this.getTeamGroupList()
		},
		// table row color
		tableRowClassName(row, index) {
			if (index % 2 === 0) {
				return 'info-row'
			}
			return ''
		},
		// tab change
		routeChange(tab) {
			console.log('--team-current-tab--', tab)
			if (tab === 'settings' || tab === 'version') {
				if (tab === 'settings') {
					this.getGroupAdminMembers()
				}
				this.getSettingFormData()
			} else if (tab === 'members') {
				this.getTeamMemberList()
			} else if (tab === 'group') {
				this.getTeamGroupList()
			} else if (tab === 'sso') {
				this.getSSOConfig()
			} else if (tab === 'ntp') {
				this.getNTPConfig()
			}
		},
		// 重置表单
		resetForm(formName) {
			this.$refs[formName].resetFields()
		},
		// 关闭侧滑
		onClosePanel() {
			this.currentRightPanel = null
			this.rightPanelData = null
		},
		trimSapce(rule, value, callback) {
			if (value.match(/^\s+$/)) {
				if (this.currentRightPanel === TeamAddMember) {
					callback(new Error(this.$gettext('Please input the name')))
				}
			} else {
				value = value.trim()
				callback()
			}
		},
		// 显示创建群组
		onShowTeamAddGroup() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamAddGroup' ? 0 : 300
			this.currentRightPanel = TeamAddGroup
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						name: {
							label: this.$gettext('Group Name'),
							val: '',
							rule: [
								{ required: true, message: this.$gettext('Please input the group name'), trigger: 'blur' },
								{ min: 2, message: this.$gettext('2-20 characters'), trigger: 'change' },
								{ max: 20, message: this.$gettext('2-20 characters'), trigger: 'change' },
							],
						},
						note: {
							label: this.$gettext('Comment'),
							val: '',
							rule: [{ max: 140, message: this.$gettext('length is within 140 characters'), trigger: 'change' }],
							type: 'textarea',
							options: {
								autosize: true,
								resize: '300',
							},
						},
					}
				}, time)
			})
		},
		// 显示设置群组信息
		onShowTeamGroupSetting(row, index) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamGroupSetting' ? 0 : 300
			this.currentRightPanel = TeamGroupSetting
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = Object.assign({}, row, { index: index })
					console.log(this.rightPanelData)
				}, time)
			})
		},
		// 显示添加成员
		onShowTeamAddMember() {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamAddMember' ? 0 : 300
			this.currentRightPanel = TeamAddMember
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = {
						account: {
							label: this.$gettext('Email'),
							val: '',
							rule: [
								{ required: true, message: this.$gettext('Please input the email'), trigger: 'blur' },
								{ required: true, pattern: /^\S+@\S+(\.\S{2,})+$/, message: this.$gettext('Please input the right email'), trigger: 'blur,change' },
							],
						},
						name: {
							label: this.$gettext('Full Name'),
							val: '',
							rule: [
								{ required: true, message: this.$gettext('Please input the name'), trigger: 'change' },
								{ min: 2, message: this.$gettext('2-16 characters'), trigger: 'change' },
								{ max: 16, message: this.$gettext('2-16 characters'), trigger: 'change' },
								{ validator: this.trimSapce, trigger: 'blur' },
							],
						},
						is_admin: {
							label: this.$gettext('Role'),
							val: 'ordinary',
							rule: { required: true, message: this.$gettext('Please select the role'), trigger: 'change' },
							type: 'select',
							options: [
								{ text: this.$gettext('ordinary user'), key: 'ordinary' },
								{ text: this.$gettext('adminstrator'), key: 'admin' },
								{ text: this.$gettext('Opt Admin'), key: 'optAdmin' },
								{ text: this.$gettext('Audit Admin'), key: 'auditAdmin' },
							],
						},
					}
				}, time)
			})
		},
		// 显示设置成员信息
		onShowTeamMemberSetting(row, index) {
			const time = !this.currentRightPanel || this.currentRightPanel.name === 'TeamMemberSetting' ? 0 : 300
			this.currentRightPanel = TeamMemberSetting
			this.$nextTick(() => {
				setTimeout(() => {
					this.rightPanelData = Object.assign({}, row, { index: index })
					console.log('setting-info', this.rightPanelData)
				}, time)
			})
		},
		// 启用/禁用
		changeStatus(row) {
			console.log(row, 'row')
			console.log(this.$store.getters.account, 'account')
			let message = `是否${row.status ? '启用' : '禁用'}成员${row.name}？`

			this.$confirm(message, {
				confirmButtonText: this.$gettext('Ok'),
				cancelButtonText: this.$gettext('Cancel'),
				type: 'warning',
			}).then(() => {
				let params = {
					data: {
						id: row.id,
						data: {
							status: !row.status,
						},
					},
				}
				this.$store.dispatch(STORE_CONST.TEAM.EDIT_MEMBER, params).then(() => {
					this.$notify({
						type: 'success',
						message: this.$gettext('update account success'),
					})
					this.getTeamMemberList(1)
				})
			})
		},

		// 文件上传成功
		uploadSuccess(response, file, fileList) {
			console.log('uploadSuccess', response, file, fileList)
			if (response) {
				console.log(fileList, 'fileList')
				this.ssoForm.fileList = fileList.slice(-1)
				console.log(this.ssoForm, 'ssoForm')

				this.$notify({
					type: 'success',
					message: this.$gettext('Upload successfully!'),
				})
			} else {
				this.$notify({
					type: 'error',
					message: response.message || this.$gettext('Upload failed!'),
				})
			}
		},

		// 删除文件
		removeFile(file, fileList) {
			console.log(file, fileList, 'file')
			this.ssoForm.fileList = fileList
		},
		// 获取SSO配置
		getSSOConfig() {
			this.loading = true

			this.$store.dispatch(STORE_CONST.TEAM.GET_SSO_CONFIG).then(
				(res) => {
					console.log(res, 'res')
					this.loading = false

					this.ssoForm = {
						is_open: res.is_open,
						is_account_password: res.is_account_password,
						sso_type: res.sso_type,
						id_vendor: res.id_vendor,
						login_url: res.login_url,
						assertion_url: res.assertion_url,
						access_white_list: res.access_white_list,
						fileList: res.fileList,
					}
					console.log(this.ssoForm, 'ssoForm')
				},
				() => {
					this.loading = false
				},
			)
		},
		// 提交SSO表单设置
		onSubmitSetSSO() {
			let data = {
				is_open: this.ssoForm.is_open,
				is_account_password: this.ssoForm.is_account_password,
				sso_type: this.ssoForm.sso_type,
				id_vendor: this.ssoForm.id_vendor,
				access_white_list: this.ssoForm.access_white_list,
			}
			this.$store.dispatch(STORE_CONST.TEAM.UPDATE_SSO_CONFIG, data).then((res) => {
				this.$notify({
					type: 'success',
					message: this.$gettext('Update SSO config successfully!'),
				})
				this.getSSOConfig()
			})
		},
		copySuccess(e) {
			this.$notify({
				message: this.$gettext('Copy successfully!'),
				type: 'success',
			})
			e.clearSelection()
		},
		// 获取NTP表单
		getNTPConfig() {
			this.loading = true
			this.$store.dispatch(STORE_CONST.TEAM.GET_NTP_CONFIG).then(
				(res) => {
					console.log(res, 'NTP配置')
					this.ntpForm = {
						ntpServer: res.host,
						currentTime: res.time,
						syncCycle: '5分钟',
						syncCountdown: this.ntpForm.syncCountdown,
					}
					this.loading = false
					this.startCountdown()
				},
				() => {
					this.loading = false
				},
			)
		},
		// 启动同步倒计时（每秒拉取服务端时间）
		startCountdown() {
			if (this.countdownInterval) clearInterval(this.countdownInterval)
			this.countdownInterval = setInterval(async () => {
				// 1. 拉取服务端时间并更新
				// 2. 倒计时递减
				this.ntpForm.currentTime++
				// 3. 倒计时结束，自动同步
				if (this.ntpForm.syncCountdown <= 0) {
					this.onManualSyncNtp()
				} else {
					this.ntpForm.syncCountdown--
				}
			}, 1000) // 每秒执行一次（拉取时间+倒计时）
		},
		async onManualSyncNtp() {
			this.ntpForm.isSyncing = true
			this.ntpForm.syncCountdown = 300

			try {
				// 1. 调用服务端同步接口（触发时间同步）
				const res = await this.$store.dispatch(STORE_CONST.TEAM.UPDATE_NTP_CONFIG, {
					host: this.ntpForm.ntpServer,
				})
				// 2. 更新当前时间（同步后立即刷新）
				this.getNTPConfig()

				// 4. 同步成功提示
				this.$notify({ type: 'success', message: this.$gettext('NTP sync success!') })
			} catch (err) {
				this.$notify({ type: 'error', message: this.$gettext('NTP sync failed!') })
			} finally {
				this.ntpForm.isSyncing = false
			}
		},
	},
	destroyed() {
		clearInterval(this.countdownInterval)
	},
	watch: {
		settingForm: {
			handler: function (newVal) {
				if (this.$refs['teamSetForm']) {
					this.$refs['teamSetForm'].validate((valid) => {
						this.settingForm.isCanSubmit = valid
					})
				}
			},
			deep: true,
		},
		ssoForm: {
			handler: function (newVal) {
				if (this.$refs['ssoSetForm']) {
					this.$refs['ssoSetForm'].validate((valid) => {
						this.ssoForm.isCanSubmit = valid
					})
				}
			},
			deep: true,
		},
		$route(to, from) {
			this.activeTab = this.$route.query.type
			this.routeChange(this.activeTab)
		},
	},
	components: {
		TeamAddMember,
		TeamMemberSetting,
		TeamAddGroup,
		TeamGroupSetting,
	},
}
</script>

<style lang="scss" rel="stylesheet/scss">
@import '../../assets/css/variable';

.team {
	.team-set {
		background-color: #fff;
		padding: 30px 0 70px 0;
		.ulit {
			color: #fea542;
		}
		.base {
			color: #43e591;
		}
		.company {
			color: #a976ff;
		}
		.test {
			color: #4488ff;
		}
		.el-tabs {
			border: 1px solid $border-color;
		}
		.el-tabs__header {
			background-color: $bgColor;
			border-bottom: 1px solid $border-color;
		}
		.el-form-item__label {
			&:before {
				content: '';
			}
		}
		.el-input__inner {
			width: 200px;
			border-radius: 0;
		}
		.el-radio-button__inner {
			border-radius: 0;
			padding: 8px 25px;
		}
		.fixed-text {
			.el-form-item__label {
				padding: 0 11px 0 0;
				line-height: -1;
			}
			.el-form-item__content {
				line-height: 13px;
			}
		}
		.set-btn {
			margin-left: 180px;
		}
		.teamToken,
		.bindedWorkSpace,
		.loginHoldTime {
			display: flex;
			align-items: center;
			.el-input {
				width: auto;
				margin-right: 20px;
			}
		}
	}
	.ssk-wrapper {
		.add-ssk {
			height: 60px;
			line-height: 60px;
			padding: 0 15px;
			background-color: #fff;
			border: 1px solid $border-color;
			border-bottom: none;
			a {
				color: $textColor;
				margin-right: 4px;
				.el-icon-plus {
					font-weight: 700;
					font-size: 12px;
					margin-right: 4px;
				}
				&:hover {
					color: $mainColor;
				}
			}
			.pull-right {
				.el-input__inner {
					border-radius: 0;
					height: 32px;
				}
				.account-search {
					width: 100px;
					.el-input__icon {
						font-size: 10px;
						width: 21px;
					}
					.el-input__inner {
						padding-right: 21px;
					}
				}
				.condition-search {
					width: 95px;
					.el-input__icon {
						font-size: 10px;
						width: 21px;
					}
					.el-input__icon + .el-input__inner {
						padding-right: 20px;
					}
				}
				.search-input {
					width: 180px;
				}
				.search-btn {
					height: 32px;
					min-width: 88px;
					padding: 0;
				}
			}
		}
	}
	.detail-wrapper {
		padding-top: 20px;
		.fixed-text {
			.el-form-item__label {
				padding: 0 11px 0 0;
				line-height: -1;
			}
			.el-form-item__content {
				line-height: 13px;
			}
		}
		.el-form-item {
			.el-form-item__label {
				&:before {
					content: '';
				}
			}
			.el-input__inner {
				border-radius: 0;
			}
			.detail-name {
				display: inline-block;
				text-align: right;
				width: 40%;
			}
			&:first-child {
				margin-top: 0;
			}
			p {
				margin-bottom: 0;
				&.m-top {
					margin-top: 10px;
				}
			}
		}
	}
	.sso {
		background-color: #fff;
		padding: 30px 0 70px 0;
		.sso-form {
			width: 50%;
		}

		.el-upload-dragger {
			height: 200px;
			p {
				padding: 0 20px;
				color: #c0c3cc;
				font-size: 12px;
			}
		}

		.set-btn {
			margin-left: 180px;
		}
		.copy-text {
			display: flex;
			align-items: center;
			.fa {
				margin-left: 10px;
			}
		}
	}
	// 新增：时钟标签样式
	.ntp {
		.ntp-wrapper {
			background-color: #fff;
			padding: 30px 20px;
			.el-form {
				width: 60%;
			}
			.el-form-item {
				margin-bottom: 20px;
				.el-checkbox {
					margin-top: 10px;
					color: #606266;
				}
			}
			.el-input__inner {
				width: 350px;
				border-radius: 0;
			}
		}
	}
}
</style>



// WEBPACK FOOTER //
// team.vue?2414d8de